import { getCurrentUser } from "controller/getCurrentUser"

export function useUserMetadata() {
    return getCurrentUser.useResults()?.metadata ?? { skills: [], __NO_USER: true }
}
